import { ShowWrapper } from "@/layouts/ShowWrapper";
import { InstanceActions, InstanceDetailTabs } from "@/resources-def";

export const ShowInstance = () => {
  return (
    <ShowWrapper
      actions={<InstanceActions />}
      details={InstanceDetailTabs()} />
  );
};